<template>
  <div class="dealTab">
    <div class="deal-tab-top">
      <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
        <div>我的结算</div>
        <div></div>
    </div>
    <div class="deal-tab">
      <van-tabs v-model="formData.tradeStatus" @click="changeTab" style="padding-bottom:45px">
        <van-tab title="结算中" name="04">
          <div class="gongdan" v-if="dealList.length===0">
            <img :src="jiesuan" alt="">
          </div>
          <div class="deal-tab-detail" v-for="item in dealList" :key="item.id" @click="toDetailPage(item)">
            <div class="tab-detail-left">
              <div class="title">{{item.taskName}}</div>
              <div class="amount">结算金额:{{item.amt}}</div>
              <div class="date">{{item.tradeAt}}</div>
            </div>
            <div class="tab-detail-right"><img :src="jiesuanicon" alt=""></div> 

          </div>
        </van-tab>
        <van-tab title="结算成功" name="00">
          <div class="gongdan" v-if="dealList.length===0">
            <img :src="jiesuan" alt="">
          </div>
          <div class="deal-tab-detail" v-for="item in dealList" :key="item.id" @click="toDetailPage(item)">
            <div class="tab-detail-left">
              <div class="title">{{item.taskName}}</div>
              <div class="amount">结算金额:{{item.amt}}</div>
              <div class="date">{{item.tradeAt}}</div>
            </div>
            <div class="tab-detail-right"><img :src="chenggongicon" alt=""></div> 
          </div>
        </van-tab>
        <van-tab title="结算失败" name="02">
          <div class="gongdan" v-if="dealList.length===0">
            <img :src="jiesuan" alt="">
          </div>
          <div class="deal-tab-detail" v-for="item in dealList" :key="item.id" @click="toDetailPage(item)">
            <div class="tab-detail-left">
              <div class="title">{{item.taskName}}</div>
              <div class="amount">结算金额:{{item.amt}}</div>
              <div class="date">{{item.tradeAt}}</div>
            </div>
            <div class="tab-detail-right"><img :src="shibaiicon" alt=""></div> 
          </div>

        </van-tab>
      </van-tabs>
      <!-- 分页 -->
    <div class="footer" v-if="dealList.length!==0">
      <van-pagination v-model="formData.currentPage" :total-items="pageCount" mode="simple" @change="changeTab" />
    </div>
    </div>
  </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      formData:{
        currentPage: 1,
	      pageSize: 10,
	      tradeStatus: "04",
	      userIdentity: 1
      },
      pageCount:"",
      dealList:[],
      jiesuan:require("../../../assets/img/jiesuan.png"),
      jiesuanicon:require("../../../assets/img/jiesuanzhongicon.png"),
      chenggongicon:require("../../../assets/img/chenggongicon.png"),
      shibaiicon:require("../../../assets/img/shibaiicon.png"),
    }
  },
  mounted(){
    const url = new URL(location.href);
    url.searchParams.get('tradeStatus') ?this.formData.tradeStatus = url.searchParams.get('tradeStatus') :this.formData.tradeStatus;
    url.searchParams.get('currentPage') ?this.formData.currentPage = url.searchParams.get('currentPage') :this.formData.currentPage;
    this.tradeOrderItemPage()
  },
  methods:{
    tradeOrderItemPage(){
      http.post(config.tradeOrderItemPage,this.formData).then(({code,data,message})=>{
        if(code===0){
          this.pageCount=data.count;
          this.dealList=data.rows;
        }else{
          this.$toast.fail(message)
        }
      })
    },
    goBack(){
      this.$router.go(-1)
    },
    toDetailPage(item){
      this.$router.push({path:"/dealOrderDetail",query:{id:item.id,tradeStatus:this.formData.tradeStatus,currentPage:this.formData.currentPage}})
    },
    changeTab(){
      this.tradeOrderItemPage()
    }
  }
}
</script>
<style lang="less" scoped>
.dealTab{
  height: 100%;
  background: #f9fafb;
  .deal-tab-top{
    display: flex;
    justify-content: space-between;
    font-size: 35px;
    padding: 20px;
    .jian{
      font-size: 35px;
    }
  }
  .deal-tab{
    .gongdan{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 60px;
      padding-top:150px;
    img{
      width: 50%;
      height: auto;
    }
    }
    .deal-tab-detail{
      display: flex;
      justify-content: space-between;
      padding: 30px;
      background: #ffffff;
      margin-top: 20px;
      align-items: center;
      .tab-detail-left{
        text-align: left;
        .title{
          font-size: 32px;
        }
        .amount{
          margin:10px 0;
          color: #777777;
        }
        .date{
          color: #777777;
        }

      }
      .tab-detail-right{
        img{
          width: 120px;
          height: auto;
        }

      }

    }
    .footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
  }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/dealOrder/dealOrderTab/index.vue